import {EventBus} from "../../events";

window.flash = function (message, type) {
    EventBus.$emit('flash', message, type);
};

window.overlay = function (message, title, type) {
    EventBus.$emit('flashOverlay', message, title, type);
};

Vue.component('flashbox', require('./components/Flashbox.vue').default);
Vue.component('flashOverlay', require('./components/FlashOverlay.vue').default);
